import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

import { addressFormFields } from './addressFieldsForm';

const formFields = [
  ...addressFormFields,
  {
    name: 'startOfResidence',
    label: 'Start Of Residence',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'endOfResidence',
    label: 'End Of Residence',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'housingType',
    label: 'Ownership Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'monthlyRentAmount',
    label: 'Monthly Rent',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'hasRelativesPartRent',
    label: 'Do you pay any rent?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'monthlyRelativesPartRentAmount',
    label: 'Monthly Relatives Part Rent',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isMailingAddressTheSameAsCurrentAddress',
    label: 'Mailing address is the same as current address',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isSubjectProperty',
    label: 'Subject Property',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  // TODO: add fields for mailing and previous addresses
];

export const borrowerAddressForm = {
  name: FormNames.BORROWER_ADDRESS,
  label: 'Address',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
